import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { useRef, useState } from 'react';
import { useSearchContext } from '../search-new/context/SearchContext';
import Slider from '../../new-components/Slider';
import { styled } from 'styled-components';
import ExplorePropertiesContainer from './components/explore-properties/ExploreNawyNowContainer';
import WebAppJourney from '../home/components/web-app-journey/WebAppJourney';
import MNawyNowFinancing from './components/MNawyNowFinancing';
import ArrowIcon from '../../new-components/svg-icons/ArrowIcon';
import ExploreNawyNowMap from './components/ExploreNawyNowMap';
import Header from './components/Header';
import HeroSection from './components/mobile/HeroSection';
import IntroSection from './components/IntroSection';
import StepsSection from './components/mobile/StepsSection';
import FilterIcon from '../../new-components/svg-icons/FilterIcon';
import { SearchFiltersTypes } from '../../reducers/search-filters/reducer';
import { ModalShowTypeState } from '../search/components/filters/mobile/MobileFilterBarPresentation';
import MobileModalFiltersView from '../search/components/filters/mobile/MobileModalFiltersView';
import QuickFilters from './components/mobile/QuickFilters';
import SearchIcon from '../../new-components/svg-icons/SearchIcon';
import { logEvent } from '../../new-lib/analytics';

const MobileNawyNowView = (props: any) => {
  const { t } = useTranslation(['nawy-now', 'common']);
  const router = useRouter();

  const {
    searchFiltersState,
    setShowFilters,
    appliedFiltersCount,
    setShowUniversalSearch
  } = useSearchContext();

  const {
    areas: areasFilters,
    compounds: compoundsFilters,
    developers: developersFilters
  } = searchFiltersState.searchFilters;

  const nawyNowAppliedFiltersCount =
    appliedFiltersCount -
    (areasFilters.length ? 1 : 0) -
    (compoundsFilters.length ? 1 : 0) -
    (developersFilters.length ? 1 : 0);

  const formRef = useRef<HTMLDivElement | null>(null);
  const propertiesRef = useRef<HTMLDivElement | null>(null);

  const [showModal, setShowModal] = useState<ModalShowTypeState>({
    show: false,
    type: SearchFiltersTypes.SORT_BY
  });

  const handleClick = () => {
    router.push(`/search?view=map`);
  };

  const closeModal = () => {
    setShowModal({
      ...showModal,
      show: false
    });
  };
  return (
    <Container>
      <Header animate={props.animate} />
      <HeroSection
        animate={props.animate}
        propertiesRef={propertiesRef}
        developerLogos={props?.developerLogos}
      />
      <IntroSection />
      <StepsSection formRef={formRef} propertiesRef={propertiesRef} />

      <div className="listing-section container-fluid">
        {props.sliderProps?.children?.length > 0 && (
          <div className="dont-miss-section">
            <div className="slider-header">{t('dont_miss')}</div>
            <Slider {...props.sliderProps} withPagination />
          </div>
        )}
        <div className="developers-slider" ref={props.containerRef}>
          <Slider {...props?.developersSliderProps} />
        </div>
        <div ref={propertiesRef}>
          <div className="properties-header">
            <div className="properties-header-title">
              <span className="header">
                {t('properties', { ns: 'common' })}
              </span>
              <button className="view-map-btn" onClick={handleClick}>
                {t('view_on_map', { ns: 'common' })}{' '}
                <ArrowIcon
                  stroke={'#1e6dac'}
                  styles={{
                    transform:
                      router.locale === 'ar' ? 'rotate(180deg)' : 'rotate(0deg)'
                  }}
                />
              </button>
            </div>

            <MobileSearch
              onClick={() => {
                setShowUniversalSearch(true);
                logEvent.click('search_click', 'Nawy_now', 'search');
              }}
            >
              <SearchIcon fill={'#788496'} />
              <span>{t('search_by_locations', { ns: 'common' })}</span>
            </MobileSearch>

            <div className="filters-section">
              <QuickFilters
                areas={props.areas}
                compounds={props.compounds}
                developers={props.developers}
              />
              <div className="search-actions">
                <FilterBtn
                  onClick={() => setShowFilters(true)}
                  count={nawyNowAppliedFiltersCount}
                >
                  <FilterIcon color="#015C9A" />
                  {nawyNowAppliedFiltersCount &&
                  nawyNowAppliedFiltersCount > 0 ? (
                    <span className="filters-indicator">
                      {nawyNowAppliedFiltersCount}
                    </span>
                  ) : null}
                </FilterBtn>
                <SortBtn
                  onClick={() => setShowModal({ ...showModal, show: true })}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="21"
                    viewBox="0 0 20 21"
                    fill="none"
                  >
                    <path
                      d="M17.5 5.6084C17.8969 5.6084 18.2246 5.93611 18.2246 6.33301C18.2246 6.7299 17.8969 7.05762 17.5 7.05762H2.5C2.1031 7.05762 1.77539 6.7299 1.77539 6.33301C1.77539 5.93611 2.1031 5.6084 2.5 5.6084H17.5Z"
                      fill="#015C9A"
                      stroke="#015C9A"
                      stroke-width="0.2"
                    />
                    <path
                      d="M15 9.77539C15.3969 9.77539 15.7246 10.1031 15.7246 10.5C15.7246 10.8969 15.3969 11.2246 15 11.2246H5C4.6031 11.2246 4.27539 10.8969 4.27539 10.5C4.27539 10.1031 4.6031 9.77539 5 9.77539H15Z"
                      fill="#015C9A"
                      stroke="#015C9A"
                      stroke-width="0.2"
                    />
                    <path
                      d="M11.6663 13.9424C12.0632 13.9424 12.3918 14.2701 12.3918 14.667C12.3918 15.0639 12.0632 15.3916 11.6663 15.3916H8.33325C7.93636 15.3916 7.60864 15.0639 7.60864 14.667C7.60864 14.2701 7.93636 13.9424 8.33325 13.9424H11.6663Z"
                      fill="#015C9A"
                      stroke="#015C9A"
                      stroke-width="0.2"
                    />
                  </svg>
                </SortBtn>
              </div>
            </div>
          </div>
          <div className="explore-properties-container">
            <ExplorePropertiesContainer
              exploreLocation="nawy_now_page"
              filterOptions={props.filterOptions}
              initialSearchResults={props?.loadedSearchResultsSSR}
            />
          </div>

          <ExploreNawyNowMap handleClick={handleClick} />

          <MNawyNowFinancing
            areas={props.areas}
            propertyTypes={props.propertyTypes}
            compounds={props.compounds}
            formRef={formRef}
          />

          <WebAppJourney />
        </div>
      </div>
      {showModal.show && (
        <MobileModalFiltersView
          modalShowType={showModal}
          closeModal={closeModal}
        />
      )}
    </Container>
  );
};
const Container = styled.div`
  display: flex;
  flex-direction: column;

  /* .filters-indicator {
    font-size: 10px !important;
    color: ${props => props.theme.light.colors.white} !important;
    background-color: ${props => props.theme.light.colors.primaryOrange};
    width: 16px;
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
  } */

  .swiper-pagination {
    bottom: -25% !important;
  }

  .listing-section {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: 16px;
  }

  .dont-miss-section {
    display: flex;
    flex-direction: column;
    gap: 24px;
    .slider-header {
      color: #2c3138;
      font-family: materialBold;
      font-size: 18px;
    }
    .swiper-slide {
      align-items: flex-start;
      justify-content: flex-start;
    }
  }

  .developers-slider {
    margin: 32px 0px 16px 0px;
  }

  .properties-header {
    display: flex;
    flex-direction: column;
    gap: 16px;
    .properties-header-title {
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      .header {
        color: #2c3138;
        font-family: materialBold;
        font-size: 18px;
        text-transform: capitalize;
      }

      .view-map-btn {
        display: flex;
        align-items: center;
        color: #1e6dac;
        background-color: transparent;
        border-color: transparent;
        font-family: materialMedium;
        font-size: 14px;
        cursor: pointer;

        svg {
          width: 16px;
          height: 16px;
          margin-left: 4px;
          stroke-width: 1px;
        }
      }
    }

    .filters-section {
      display: flex;
      flex-direction: row;
      align-items: center;
      height: 40px;

      > div {
        padding: 0;
        height: 40px;
      }
    }

    .search-actions {
      display: flex;
      flex: 1;
      flex-direction: row;
      align-items: center;
      justify-content: flex-end;
      gap: 12px;

      svg {
        width: 20px;
        height: 20px;
      }
    }
  }
`;

const FilterBtn = styled.button<any>`
  position: relative;
  background-color: ${props => (props.count > 0 ? '#f4f9fe' : 'transparent')};
  /* border: ${props => (props.count > 0 ? 'none' : '1px solid #d3dbe6')}; */
  border: none;
  border-radius: 8px;
  padding: 6px;
  outline: none;
  /* border: none; */
  color: #015c9a;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  font-family: materialMedium;
  line-height: 150%;
  cursor: pointer;
  svg {
    width: 20px;
    height: 20px;
  }

  span {
    font-size: 10px;
    color: ${props => props.theme.light.colors.white};
    background-color: ${props => props.theme.light.colors.primaryOrange};
    width: 16px;
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
  }

  .filters-indicator {
    position: absolute;
    top: -3px;
    inset-inline-end: -6px;
    font-size: 10px;
    color: #fff;
    background-color: #ff3a00;
    width: 14px;
    height: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
  }
`;

const SortBtn = styled.button`
  background-color: transparent;
  outline: none;
  border: none;
  color: #015c9a;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  font-family: materialMedium;
  line-height: 150%;
  cursor: pointer;
  svg {
    width: 20px;
    height: 20px;
  }

  span {
    font-size: 10px;
    color: ${props => props.theme.light.colors.white};
    background-color: ${props => props.theme.light.colors.primaryOrange};
    width: 16px;
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
  }
`;

const MobileSearch = styled.button`
  width: 100%;
  padding: 8px;
  border: none;
  border-radius: 12px;
  border: 1px solid #c6d0de;
  background: #fbfcfe;
  display: flex;
  align-items: center;
  position: relative;
  font-family: materialLight;
  font-size: ${props => props.theme.font.sizes.s};
  color: ${props => props.theme.light.colors.darkGrey};
  gap: 4px;
  height: 50px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;

  span {
    color: #5b6573;
    font-size: 14px;
  }
  svg {
    min-width: 20px;
    height: 20px;
    path {
      fill: ${props => props.theme.light.colors.darkGrey};
    }
  }
`;

export default MobileNawyNowView;
